<template>
  <div class="common_search">
    <div class="inputRegion">
      <slot name="inputRegion" />
    </div>
    <div class="buttonBar">
      <slot name="buttons" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonSearch',
  data () {
    return {};
  },
  components: {},
  computed: {},
  methods: {},
  mounted () {}
};
</script>
<style lang="scss" scoped>
.common_search {
  width: 100%;
  padding: 20px 20px;
  background: #ffffff;
  margin-bottom: 15px;
  //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  > .inputRegion {
    &:after {
      content: "";
      height: 0;
      clear: both;
      display: block;
    }
    ::v-deep > .col {
      width: 240px;
      margin-bottom: 20px;
      float: left;
      margin-left: 40px;
      > .label {
        width: 100%;
        margin-bottom: 6px;
      }
      > .inputBox {
        width: 100%;
        > .el-input > input {
          height: 36px;
        }
        >.el-select{
          width: 100%;
        }
      }
    }
  }

  > .buttonBar {
    display: flex;
    justify-content: center;
    >button{
      margin: 0 20px;
    }
  }
}
</style>
